import { Share as ShareIcon } from '@mui/icons-material';
import {
  Alert,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  ListItemText,
  Skeleton,
  Typography,
} from '@mui/material';
import logo from '../../assets/images/logo-small.png';
import { formatDateTime, formatearFecha } from '../../@iosper/utils/Format';
import { useEffect, useState } from 'react';
import { validarTokenCredencial } from '../../services/Afiliado/Afiliado';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const DrawerDataField = ({ label, data, loading = false, style = {} }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 0, sm: 1 },
        alignItems: 'baseline',
        width: '100%',
      }}
    >
      {loading && (
        <Skeleton
          variant='text'
          sx={{ fontSize: '1.9rem', width: { xs: 230, sm: 380 }, ...style }}
        />
      )}
      {!loading && (
        <>
          <Typography variant='body' fontWeight={700}>
            {label}
          </Typography>
          <ListItemText primary={data} />
        </>
      )}
    </Box>
  );
};

const CredencialAfiliado = () => {
  const { dataBase64 } = useParams();
  const [afiliado, setAfiliado] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getCredencial = async (data) => {
      try {
        const credencialAfiliado = await validarTokenCredencial(data)
          .then((res) => {
            setAfiliado(res);
            setLoading(false);
          })
          .catch((err) => {
            setError('No se ha podido escanear el código QR, Por favor vuelva a intentar.');
            setLoading(false);
          });
      } catch (e) {
        setLoading(false);
      }

      setLoading(false);
    };

    if (dataBase64) {
      getCredencial(dataBase64);
    }
  }, []);

  return (
    <Container component={'main'} maxWidth='md' sx={{ display: 'flex', justifyContent: 'center' }}>
      <Card sx={{ maxWidth: 450 }}>
        <CardHeader
          avatar={<img src={logo} alt='OSER' style={{ width: 40, height: 40 }} />}
          title={
            <Typography variant='h3' component={'h1'} fontSize={{ xs: '1.3rem', sm: '1.5rem' }}>
              <b>OSER</b> <br /> Credencial Electrónica
            </Typography>
          }
        />
        <CardContent sx={{ py: 0 }}>
          {error && (
            <Grid container spacing={0} sx={{ p: 2, minHeight: '150px', alignContent: 'center' }}>
              <Alert severity='warning'>{error}</Alert>
            </Grid>
          )}

          {!error && (
            <Grid container spacing={0} sx={{ py: 0, px: 2 }}>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Afiliado'
                  data={afiliado ? `${afiliado?.apellido}, ${afiliado?.nombre}` : ''}
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField label='Cuit/Cuil' data={afiliado?.cuilCuit} loading={loading} />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Fecha Nacimiento'
                  data={formatearFecha(afiliado?.fechaNacimiento, 'dd/mm/yyyy')}
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Residencia'
                  data={`${afiliado?.localidad}, ${afiliado?.provincia}`}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Relación'
                  data={afiliado?.relacionTitularAdherente}
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Tipo Afiliado'
                  data={afiliado?.tipoAfiliado}
                  loading={loading}
                />
              </Grid>
              {afiliado?.derivacion && (
                <>
                  <Grid item xs={12} my={2}>
                    <Typography variant='body2' fontSize={18}>
                      Afiliado Derivado
                    </Typography>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <DrawerDataField
                      label='Tipo Derivación'
                      data={afiliado?.derivacion?.descripcionTipoDerivacion}
                      style={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 1 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DrawerDataField
                      label='Destino'
                      data={`${afiliado?.derivacion?.obraSocialDescripcion || ''} ${
                        afiliado?.derivacion?.obraSocialSigla
                          ? '(' + afiliado.derivacion.obraSocialSigla + ')'
                          : ''
                      } - ${afiliado?.derivacion?.obraSocialProvincia || ''}`}
                      style={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 1 } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DrawerDataField
                      label='Desde'
                      data={formatearFecha(afiliado?.derivacion?.fechaDesde)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DrawerDataField
                      label='Hasta'
                      data={formatearFecha(afiliado?.derivacion?.fechaHasta)}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} mt={2}>
                {loading && <Skeleton variant='text' sx={{ fontSize: '1.9rem' }} />}
                {!loading && (
                  <Typography variant='body2'>
                    Fecha de emisión {formatDateTime(afiliado?.fechaCreacion)}
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}
        </CardContent>
        {/* <CardActions disableSpacing sx={{ p: 2 }}>
          <IconButton aria-label='share'>
            <ShareIcon />
          </IconButton>
        </CardActions> */}
      </Card>
    </Container>
  );
};

export default CredencialAfiliado;
